import { signal } from '@preact/signals-react'
import {TABS_OFFERS} from "./@constants";


export const isEmptyFlashOffers = signal(false)
export const customDashboardsPrimorTabID = signal(TABS_OFFERS.DRUNI)
export const customDashboardsPrimorIsLoadingOffers = signal(true)
export const flashOffersReportDrawerIsOpen = signal(false)
export const flashOffersError = signal(null)

export const resetFlashOffersSignals = () => {
    isEmptyFlashOffers.value = false
    customDashboardsPrimorTabID.value = TABS_OFFERS.DRUNI
    customDashboardsPrimorIsLoadingOffers.value = true
    flashOffersReportDrawerIsOpen.value = false
    flashOffersError.value = null
}